<template>
  <div class="search-section container mt-4">
    <div v-if="!searching" class="d-grid shadow-sm rounded-pill overflow-hidden">
      <button class="btn btn-search-trigger py-2 fw-bold" @click="searching = true">
        <i class="fas fa-search me-2"></i> Search for a specific task...
      </button>
    </div>

    <div v-else class="search-active-container p-3 bg-white shadow-sm rounded-4 border">
      <div class="row g-2 align-items-center">
        <div class="col-md-7">
          <div class="input-group">
            <span class="input-group-text bg-transparent border-end-0">
              <i class="fas fa-keyboard text-muted"></i>
            </span>
            <input 
              type="text" 
              class="form-control border-start-0 ps-0 shadow-none" 
              placeholder="Type task title or date..." 
              v-model="searchQuery"
              @input="handleSearch"
            >
          </div>
        </div>
        <div class="col-md-3">
          <select class="form-select shadow-none" v-model="statusFilter" @change="handleSearch">
            <option value="">All Statuses</option>
            <option value="to do">To Do</option>
            <option value="in progress">In Progress</option>
            <option value="done">Done</option>
          </select>
        </div>
        <div class="col-md-2">
          <button class="btn btn-outline-secondary w-100" @click="cancelSearch">
            Cancel
          </button>
        </div>
      </div>
      
      <div v-if="searchQuery" class="mt-2 small text-muted px-2">
        Found <span class="text-primary fw-bold">{{ filteredTasks.length }}</span> results
      </div>
    </div>
  </div>
</template>

<script>
import { tasksService } from '@/services/tasksService';

export default {
    name: "SearchOnTask",
    props: {
    currentGroupId: {
        type: [Number, String],
        default: null
    }
},
    data() {
        return {
            searching: false,
            searchQuery: "",     
            statusFilter: "",    
            allTasks: [],        
            filteredTasks: []   
        }
    },
  
  
    methods: {
    async handleSearch() {
         
        if (this.allTasks.length === 0) {
             
            const res = await tasksService.getAllTasks(this.currentGroupId);
            this.allTasks = res || [];
        }

        const query = this.searchQuery.toLowerCase().trim();
        
        this.filteredTasks = this.allTasks.filter(task => {
            const matchesTitle = task.title.toLowerCase().includes(query);
            const matchesStatus = this.statusFilter ? task.status.toLowerCase() === this.statusFilter.toLowerCase() : true;
            const matchesDate = task.created_at ? task.created_at.includes(query) : false;
            
            return (matchesTitle || matchesDate) && matchesStatus;
        });
        
        this.$emit('search-results', this.filteredTasks);
    },
  cancelSearch() {
            this.searching = false;     
            this.searchQuery = "";      
            this.statusFilter = "";     
            this.allTasks = [];         
            this.$emit('search-results', null);  
        }
},

watch: {
        currentGroupId() {
            this.allTasks = []; 
            this.handleSearch(); 
        }
    },


}
</script>

<style lang="scss" scoped>
.btn-search-trigger {
    background: linear-gradient(45deg, #6a11cb 0%, #2575fc 100%);
    color: white;
    border: none;
    transition: all 0.3s ease;
    letter-spacing: 0.5px;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(37, 117, 252, 0.4);
        color: white;
    }
}

.search-active-container {
    border: 1px solid #eef2f7 !important;
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
}

.input-group-text {
    border-color: #dee2e6;
}

.form-control, .form-select {
    border-color: #dee2e6;
    &:focus {
        border-color: #2575fc;
    }
}
.form-select {
    border:solid 1px #008000;
    margin: 2px;
    padding: 5px;
    font-family: sans-serif;
    font-weight: bold;
    background-color: rgba(222, 184, 135, 0.545);
    border-radius: 5px;
}
</style>